import React from "react"
import styled from "styled-components"
import CopyIcon from "../../../public/assets/icons/CopyIcon"
import PrintIcon from "../../../public/assets/icons/PrintIcon"
import SearchIcon from "../../../public/assets/icons/SearchIcon"
import LeftArrowIcon from "../../../public/assets/icons/LeftArrowIcon"
import RightArrowIcon from "../../../public/assets/icons/RightArrowIcon"
import PrintIconBlack from "../../../public/assets/icons/PrintIconBlack"
import ExcelIcon from "../../../public/assets/icons/ExcelIcon"
import {
  CheckOutlined,
  CloseCircleFilled,
  CloseCircleOutlined,
  DeleteOutlined,
  FormOutlined,
  LoadingOutlined,
  LockOutlined,
  PlusCircleFilled,
  QuestionCircleOutlined,
  UnlockOutlined,
  UpOutlined,
} from "@ant-design/icons"
import { theme } from "@project/shared"
import { Spin } from "antd"
import ArrowDownIcon from "../../../public/assets/icons/ArrowDownIcon"
import ExcelIconWhite from "../../../public/assets/icons/excelIconWhite"
export interface Props {
  text?: string
  icon?:
    | "search"
    | "print"
    | "copy"
    | "pdf"
    | "left-arrow"
    | "right-arrow"
    | "none"
    | "add"
    | "close"
    | "check-all"
    | "edit"
    | "down"
    | "printBlack"
    | "lock"
    | "unlock"
    | "up"
    | "close-circle-outlined"
    | "delete-outlined"
    | "excel"
    | "question_mark_outlined"
    | "question_mark"
    | "check_mark"
    | "csv-icon"
    | "whiteExcel"
    | "text-output"
  iconPosition?: "left" | "right"
  shape?: "round" | "circle"
  color?: string
  borderColor?: string
  backgroundColor?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  type?: "submit" | "button"
  padding?: number
  radius?: number
  className?: string
  width?: number
  disabled?: boolean
  typeOf?:
    | "primary"
    | "secondary"
    | "search"
    | "copy"
    | "pdf"
    | "draft"
    | "check-all"
    | "outlined"
    | "link"
    | "print"
    | "show"
    | "printBlack"
    | "private-no-publish"
    | "publish"
    | "excel"
    | "csv-btn"
    | "text-output"

  isLoading?: boolean
}

interface StyledButtonProps {
  color: string
  backgroundColor: string
  borderColor: string
  padding?: number
  radius?: number
  width?: number
  typeOf?: "primary" | "secondary"
  isLoading?: boolean
}

interface IconPosition {
  position: string
}

const ButtonStyled = styled.button<StyledButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
  cursor: pointer;
  padding: ${(props) => (props?.padding ? `${props?.padding}px` : `12px 30px`)};
  color: ${(props) => props.color};
  border: 1px solid ${(props) => props.borderColor};
  background-color: ${(props) => props.backgroundColor};
  &.circular-radius {
    border-radius: 100px;
  }
  &.round-radius {
    border-radius: ${(props) => (props?.radius ? `${props?.radius}px` : "5px")};
  }
  font-size: 14px;
  width: ${(props) => (props?.width ? `${props?.width}px` : ``)};
  word-break: keep-all;
  white-space: nowrap;

  &.break-text-all {
    word-break: break-all;
    white-space: normal;
    line-height: 1.5;
  }
  &:disabled {
    cursor: not-allowed;
  }
`

const IconStyled = styled.div<IconPosition>`
  display: flex;
  align-items: center;
  margin-right: ${(props) => (props.position === "left" ? "10px" : "0px")};
  margin-left: ${(props) => (props.position === "right" ? "10px" : "0px")};
`

const Button: React.FC<Props> = (props) => {
  const {
    text,
    icon = "none",
    iconPosition = "left",
    shape = "round",
    color = "#000000",
    borderColor = "transparent",
    backgroundColor = "#F6F7F8",
    onClick,
    className,
    type = "button",
    disabled = false,
    isLoading,
  } = props
  const getIcon = (position) => {
    switch (icon) {
      case "search":
        return (
          <IconStyled position={position}>
            <SearchIcon />
          </IconStyled>
        )
      case "print":
        return (
          <IconStyled position={position}>
            <PrintIcon />
          </IconStyled>
        )
      case "pdf":
        return (
          <IconStyled position={position}>
            <svg
              width={"18"}
              height={"18"}
              viewBox={"0 0 12 13"}
              fill={"none"}
              xmlns={"http://www.w3.org/2000/svg"}
            >
              <path
                d={
                  "M1 7.37504C1.09946 7.37504 1.19484 7.33553 1.26517 7.26521C1.33549 7.19488 1.375 7.0995 1.375 7.00004V1.50004C1.375 1.46689 1.38817 1.43509 1.41161 1.41165C1.43505 1.38821 1.46685 1.37504 1.5 1.37504H7.125V4.50004C7.125 4.5995 7.16451 4.69488 7.23483 4.76521C7.30516 4.83553 7.40054 4.87504 7.5 4.87504H10.625V7.00004C10.625 7.0995 10.6645 7.19488 10.7348 7.26521C10.8052 7.33553 10.9005 7.37504 11 7.37504C11.0995 7.37504 11.1948 7.33553 11.2652 7.26521C11.3355 7.19488 11.375 7.0995 11.375 7.00004V4.50004C11.3751 4.45001 11.3652 4.40045 11.3459 4.35429C11.3266 4.30814 11.2982 4.26632 11.2625 4.23129L7.7625 0.737541C7.72911 0.701389 7.68848 0.672684 7.64325 0.653299C7.59802 0.633914 7.5492 0.624286 7.5 0.625041H1.5C1.26794 0.625041 1.04538 0.717229 0.881282 0.881323C0.717187 1.04542 0.625 1.26798 0.625 1.50004V7.00004C0.625 7.0995 0.664509 7.19488 0.734835 7.26521C0.805161 7.33553 0.900544 7.37504 1 7.37504ZM7.875 1.90629L10.0938 4.12504H7.875V1.90629ZM2 9.12504H1C0.900544 9.12504 0.805161 9.16455 0.734835 9.23488C0.664509 9.3052 0.625 9.40058 0.625 9.50004V12.5C0.625 12.5995 0.664509 12.6949 0.734835 12.7652C0.805161 12.8355 0.900544 12.875 1 12.875C1.09946 12.875 1.19484 12.8355 1.26517 12.7652C1.33549 12.6949 1.375 12.5995 1.375 12.5V11.875H2C2.36467 11.875 2.71441 11.7302 2.97227 11.4723C3.23013 11.2145 3.375 10.8647 3.375 10.5C3.375 10.1354 3.23013 9.78563 2.97227 9.52777C2.71441 9.26991 2.36467 9.12504 2 9.12504ZM2 11.125H1.375V9.87504H2C2.16576 9.87504 2.32473 9.94089 2.44194 10.0581C2.55915 10.1753 2.625 10.3343 2.625 10.5C2.625 10.6658 2.55915 10.8248 2.44194 10.942C2.32473 11.0592 2.16576 11.125 2 11.125V11.125ZM10.125 9.87504V10.875H11.25C11.3495 10.875 11.4448 10.9145 11.5152 10.9849C11.5855 11.0552 11.625 11.1506 11.625 11.25C11.625 11.3495 11.5855 11.4449 11.5152 11.5152C11.4448 11.5855 11.3495 11.625 11.25 11.625H10.125V12.5C10.125 12.5995 10.0855 12.6949 10.0152 12.7652C9.94484 12.8355 9.84946 12.875 9.75 12.875C9.65054 12.875 9.55516 12.8355 9.48483 12.7652C9.41451 12.6949 9.375 12.5995 9.375 12.5V9.50004C9.375 9.40058 9.41451 9.3052 9.48483 9.23488C9.55516 9.16455 9.65054 9.12504 9.75 9.12504H11.5C11.5995 9.12504 11.6948 9.16455 11.7652 9.23488C11.8355 9.3052 11.875 9.40058 11.875 9.50004C11.875 9.5995 11.8355 9.69488 11.7652 9.76521C11.6948 9.83553 11.5995 9.87504 11.5 9.87504H10.125ZM6 9.12504H5.125C5.02554 9.12504 4.93016 9.16455 4.85984 9.23488C4.78951 9.3052 4.75 9.40058 4.75 9.50004V12.5C4.75 12.5995 4.78951 12.6949 4.85984 12.7652C4.93016 12.8355 5.02554 12.875 5.125 12.875H6C6.49728 12.875 6.97419 12.6775 7.32582 12.3259C7.67746 11.9742 7.875 11.4973 7.875 11C7.875 10.5028 7.67746 10.0258 7.32582 9.67422C6.97419 9.32259 6.49728 9.12504 6 9.12504ZM6 12.125H5.5V9.87504H6C6.29837 9.87504 6.58452 9.99357 6.7955 10.2045C7.00647 10.4155 7.125 10.7017 7.125 11C7.125 11.2984 7.00647 11.5846 6.7955 11.7955C6.58452 12.0065 6.29837 12.125 6 12.125Z"
                }
                fill={"black"}
              />
            </svg>
          </IconStyled>
        )
      case "printBlack":
        return (
          <IconStyled position={position}>
            <PrintIconBlack />
          </IconStyled>
        )
      case "copy":
        return (
          <IconStyled position={position}>
            <CopyIcon />
          </IconStyled>
        )
      case "left-arrow":
        return (
          <IconStyled position={position}>
            <LeftArrowIcon />
          </IconStyled>
        )
      case "down":
        return (
          <IconStyled position={position}>
            <ArrowDownIcon />
          </IconStyled>
        )
      case "right-arrow":
        return (
          <IconStyled position={position}>
            <RightArrowIcon />
          </IconStyled>
        )
      case "add":
        return (
          <IconStyled position={position}>
            <PlusCircleFilled style={{ color: theme.gray3 }} />
          </IconStyled>
        )
      case "close":
        return (
          <IconStyled position={position}>
            <CloseCircleFilled style={{ color: theme.alert }} />
          </IconStyled>
        )
      case "check-all":
        return (
          <IconStyled position={position}>
            <img src={"/assets/icons/CheckAllIcon.svg"} />
          </IconStyled>
        )
      case "lock":
        return (
          <IconStyled position={position}>
            <LockOutlined />
          </IconStyled>
        )
      case "unlock":
        return (
          <IconStyled position={position}>
            <UnlockOutlined />
          </IconStyled>
        )
      case "edit":
        return (
          <IconStyled position={position}>
            <FormOutlined />
          </IconStyled>
        )
      case "up":
        return (
          <IconStyled position={position}>
            <UpOutlined />
          </IconStyled>
        )
      case "close-circle-outlined":
        return (
          <IconStyled position={position}>
            <CloseCircleOutlined style={{ color: theme.alert }} />
          </IconStyled>
        )
      case "excel":
        return (
          <IconStyled position={position}>
            <ExcelIcon />
          </IconStyled>
        )
      case "whiteExcel":
        return (
          <IconStyled position={position}>
            <ExcelIconWhite />
          </IconStyled>
        )
      case "delete-outlined":
        return (
          <IconStyled position={position}>
            <DeleteOutlined style={{ color: "red" }} />
          </IconStyled>
        )
      case "question_mark":
        return (
          <IconStyled position={position}>
            <img src={"/assets/icons/question_mark.svg"} alt={""} />
          </IconStyled>
        )
      case "question_mark_outlined":
        return (
          <IconStyled position={position}>
            <QuestionCircleOutlined />{" "}
          </IconStyled>
        )
      case "check_mark":
        return (
          <IconStyled position={position}>
            <CheckOutlined />
          </IconStyled>
        )
      case "csv-icon":
        return (
          <IconStyled position={position}>
            <img
              src={`${
                disabled
                  ? "/assets/icons/grey-paper-with-cross-icon.svg"
                  : "/assets/icons/paper-with-cross-icon.svg"
              }`}
              alt={"paper with cross icon "}
            />
          </IconStyled>
        )

      case "text-output":
        return (
          <IconStyled position={position}>
            <img
              style={{
                height: "14px",
              }}
              src={"/assets/icons/daily-report.svg"}
            />
          </IconStyled>
        )
    }
    return <></>
  }
  const antIcon = <LoadingOutlined style={{ fontSize: 18 }} spin />
  if (isLoading) {
    return (
      <ButtonStyled
        className={
          shape === "round"
            ? `round-radius ${className}`
            : `circular-radius ${className}`
        }
        color={color}
        borderColor={borderColor}
        backgroundColor={backgroundColor}
        onClick={onClick}
        type={type}
        padding={props?.padding}
        radius={props?.radius}
        width={props?.width}
        disabled
      >
        <IconStyled position={"left"} style={{ height: "19px" }}>
          <Spin indicator={antIcon} style={{ color: `${color || "white"}` }} />
        </IconStyled>
        {text}
      </ButtonStyled>
    )
  }
  return (
    <ButtonStyled
      className={
        shape === "round"
          ? `round-radius ${className}`
          : `circular-radius ${className}`
      }
      color={color}
      borderColor={borderColor}
      backgroundColor={backgroundColor}
      onClick={onClick}
      type={type}
      padding={props?.padding}
      radius={props?.radius}
      width={props?.width}
      disabled={disabled}
    >
      {icon && iconPosition === "left" && getIcon(iconPosition)}
      {text}
      {icon && iconPosition === "right" && getIcon(iconPosition)}
    </ButtonStyled>
  )
}

export { Button }
